(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["july-offer-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('july-offer-builder')) {
    customElements.define('july-offer-builder', class JulyOfferBuilder extends HTMLElement {
      connectedCallback() {
        document.body.classList.add('july-offer-page');
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.stepButtons = Array.from(this.querySelectorAll('[data-step-target]'));
        this.routeButtons = Array.from(this.querySelectorAll('[data-route-control]'));
        this.deviceVisuals = Array.from(this.querySelectorAll('[data-device-visual]'));
        this.cardVisuals = Array.from(this.querySelectorAll('[data-card-visual]'));
        this.colorGroups = Array.from(this.querySelectorAll('[data-colors-route]'));
        this.scentGroups = Array.from(this.querySelectorAll('[data-scents-route]'));
        this.upsells = Array.from(this.querySelectorAll('[data-upsell]'));
        this.countdowns = Array.from(this.querySelectorAll('[data-countdown]'));
        this.infoModal = this.querySelector('[data-device-info-modal]');
        this.infoDialog = this.querySelector('[data-device-info-dialog]');
        this.infoTitle = this.querySelector('[data-device-info-title]');
        this.infoPanels = Array.from(this.querySelectorAll('[data-device-info-panel]'));
        this.submitButton = this.querySelector('[data-add-offer]');
        this.message = this.querySelector('[data-offer-message]');
        this.state = {};
        this.handleDeviceInfoKeydown = this.handleDeviceInfoKeydown.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
        this.stepButtons.forEach((button) => button.addEventListener('click', () => this.goTo(button.dataset.stepTarget)));
        this.querySelectorAll('[data-slide-next]').forEach((button) => {
          button.addEventListener('click', () => this.goTo(button.dataset.slideNext));
        });
        this.querySelectorAll('[data-slide-prev]').forEach((button) => {
          button.addEventListener('click', () => this.goTo(button.dataset.slidePrev));
        });
        this.routeButtons.forEach((button) => button.addEventListener('click', () => this.setRoute(button.dataset.route)));
        this.querySelectorAll('[data-device-info]').forEach((button) => {
          button.addEventListener('click', () => this.openDeviceInfo(button.dataset.deviceInfo, button));
        });
        this.querySelectorAll('[data-device-info-current]').forEach((button) => {
          button.addEventListener('click', () => this.openDeviceInfo(this.state.route || this.dataset.activeRoute || 'whisper', button));
        });
        this.querySelectorAll('[data-device-info-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeDeviceInfo());
        });
        this.querySelector('[data-device-info-continue]')?.addEventListener('click', () => {
          if (this.infoRoute) this.setRoute(this.infoRoute);
          this.closeDeviceInfo();
        });
        this.querySelectorAll('[data-diffuser-variant]').forEach((button) => {
          button.addEventListener('click', () => this.selectDiffuser(button));
        });
        this.querySelectorAll('[data-scent-variant]').forEach((button) => {
          button.addEventListener('click', () => this.selectScent(button));
        });
        this.querySelectorAll('[data-upgrade-route]').forEach((button) => {
          button.addEventListener('click', () => {
            this.setRoute(button.dataset.upgradeRoute);
            this.goTo('scent');
          });
        });
        this.submitButton?.addEventListener('click', () => this.addOffer());
        this.setRoute(this.dataset.activeRoute || 'whisper');
        this.goTo('device', false);
        this.setupCountdown();
        document.addEventListener('keydown', this.handleDeviceInfoKeydown);
        window.addEventListener('pageshow', this.handlePageShow);
      }

      disconnectedCallback() {
        document.body.classList.remove('july-offer-page');
        document.body.classList.remove('july-offer-info-open');
        document.body.classList.remove('july-offer-cart-routing');
        if (this.countdownTimer) window.clearInterval(this.countdownTimer);
        if (this.handleDeviceInfoKeydown) document.removeEventListener('keydown', this.handleDeviceInfoKeydown);
        if (this.handlePageShow) window.removeEventListener('pageshow', this.handlePageShow);
      }

      setRoute(route) {
        const routeButton = this.routeButtons.find((button) => button.dataset.route === route);
        if (!routeButton) return;
        this.dataset.activeRoute = route;
        this.state.route = route;
        this.state.deviceTitle = routeButton.dataset.deviceTitle || '';
        this.state.requiredSize = routeButton.dataset.requiredSize || '';
        this.state.paidPrice = routeButton.dataset.paidPrice || '';
        this.state.freeValue = routeButton.dataset.freeValue || '';
        this.state.visualCopy = routeButton.dataset.routeVisualCopy || '';
        this.state.scentVariant = '';
        this.state.scentTitle = '';
        this.state.scentPrice = '';
        this.state.scentNotes = '';
        this.routeButtons.forEach((button) => {
          const active = button.dataset.route === route;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          button.closest('[data-route-card]')?.classList.toggle('is-active', active);
        });
        this.colorGroups.forEach((group) => {
          const active = group.dataset.colorsRoute === route;
          group.hidden = !active;
          group.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.scentGroups.forEach((group) => {
          const active = group.dataset.scentsRoute === route;
          group.hidden = !active;
          group.setAttribute('aria-hidden', active ? 'false' : 'true');
          group.querySelectorAll('[data-scent-variant]').forEach((card) => card.classList.remove('is-active'));
        });
        this.upsells.forEach((upsell) => {
          const active = upsell.dataset.upsell === route;
          upsell.hidden = !active;
        });
        const activeColor = this.querySelector(`[data-colors-route="${route}"] [data-diffuser-variant].is-active:not([disabled])`)
          || this.querySelector(`[data-colors-route="${route}"] [data-diffuser-variant]:not([disabled])`);
        if (activeColor) this.selectDiffuser(activeColor);
        if (this.currentSlide === 'review') this.goTo('scent');
        this.updateReview();
      }

      openDeviceInfo(route, trigger) {
        if (!this.infoModal || !this.infoDialog) return;
        const selectedRoute = route || this.state.route || this.dataset.activeRoute || 'whisper';
        const activePanel = this.infoPanels.find((panel) => panel.dataset.deviceInfoPanel === selectedRoute);
        if (!activePanel) return;
        this.infoRoute = selectedRoute;
        this.infoTrigger = trigger || document.activeElement;
        this.infoPanels.forEach((panel) => {
          const active = panel === activePanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (this.infoTitle) this.infoTitle.textContent = activePanel.dataset.deviceInfoTitle || 'Device details';
        this.infoModal.hidden = false;
        document.body.classList.add('july-offer-info-open');
        window.requestAnimationFrame(() => {
          this.infoDialog.focus({ preventScroll: true });
        });
      }

      closeDeviceInfo(returnFocus = true) {
        if (!this.infoModal || this.infoModal.hidden) return;
        this.infoModal.hidden = true;
        document.body.classList.remove('july-offer-info-open');
        const focusTarget = this.infoTrigger;
        this.infoTrigger = null;
        if (returnFocus && focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }

      handleDeviceInfoKeydown(event) {
        if (!this.infoModal || this.infoModal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeDeviceInfo();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.infoModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.disabled && !element.hidden && element.offsetParent !== null && !element.classList.contains('july-offer__spec-backdrop'));
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handlePageShow() {
        document.body.classList.remove('july-offer-cart-routing');
        if (!this.submitButton) return;
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Add offer to cart'));
        this.updateReview();
      }

      selectDiffuser(button) {
        const group = button.closest('[data-colors-route]');
        group?.querySelectorAll('[data-diffuser-variant]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        this.state.diffuserVariant = button.dataset.diffuserVariant;
        this.state.deviceTitle = button.dataset.diffuserTitle || this.state.deviceTitle;
        this.state.colorTitle = button.dataset.colorTitle;
        this.state.colorKey = button.dataset.colorKey || this.normalizeColor(button.dataset.colorTitle);
        this.updateDeviceVisuals();
        this.updateReview();
      }

      updateDeviceVisuals() {
        const route = this.state.route || this.dataset.activeRoute || 'whisper';
        const color = this.state.colorKey || 'black';
        this.deviceVisuals.forEach((visual) => {
          const active = visual.dataset.routeVisual === route && visual.dataset.colorKey === color;
          visual.classList.toggle('is-active', active);
        });
        this.cardVisuals.forEach((visual) => {
          const visualRoute = visual.dataset.routeVisual || '';
          const defaultColor = visualRoute === 'aura' ? 'black' : 'black';
          const desiredColor = visualRoute === route ? color : defaultColor;
          visual.classList.toggle('is-active', visual.dataset.colorKey === desiredColor);
        });
      }

      normalizeColor(value = '') {
        const color = value.toLowerCase().trim();
        if (color.includes('grey')) return 'gray';
        if (color.includes('gray')) return 'gray';
        if (color.includes('white')) return 'white';
        return 'black';
      }

      selectScent(button) {
        const group = button.closest('[data-scents-route]');
        group?.querySelectorAll('[data-scent-variant]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        this.state.scentVariant = button.dataset.scentVariant;
        this.state.scentTitle = button.dataset.scentTitle;
        this.state.scentPrice = button.dataset.scentPrice;
        this.state.requiredSize = button.dataset.scentSize;
        this.state.scentNotes = button.dataset.scentNotes;
        this.updateReview();
      }

      goTo(slide, focus = true) {
        if (slide === 'review' && !this.state.scentVariant) {
          if (this.message) this.message.textContent = 'Choose a scent oil to continue.';
          return;
        }
        if (slide === 'scent' && !this.state.diffuserVariant) return;
        this.currentSlide = slide;
        this.slides.forEach((panel) => {
          const active = panel.dataset.slide === slide;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        this.stepButtons.forEach((button) => {
          const active = button.dataset.stepTarget === slide;
          button.classList.toggle('is-active', active);
          if (active) {
            button.setAttribute('aria-current', 'step');
          } else {
            button.removeAttribute('aria-current');
          }
        });
        if (focus) {
          if (window.matchMedia('(max-width: 749px)').matches) {
            const activePanel = this.querySelector(`[data-slide="${slide}"]`);
            const scrollTarget = activePanel?.querySelector('.july-offer__slide-head') || this.querySelector('.july-offer__slides');
            const header = document.querySelector('.shopify-section-header, sticky-header, header');
            const headerOffset = header ? header.getBoundingClientRect().height : 96;
            if (scrollTarget) {
              const top = scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
              window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
            }
          }
          const target = this.querySelector(`[data-slide="${slide}"] h2`);
          target?.setAttribute('tabindex', '-1');
          target?.focus({ preventScroll: true });
        }
        this.updateReview();
      }

      updateReview() {
        const ready = Boolean(this.state.diffuserVariant && this.state.scentVariant);
        this.updateText('[data-visual-title]', this.state.deviceTitle);
        this.updateText('[data-visual-copy]', this.state.visualCopy);
        this.updateText('[data-visual-value]', this.state.freeValue || '');
        this.updateText('[data-color-heading]', this.state.deviceTitle);
        this.updateText('[data-scent-heading]', `Choose any ${this.state.requiredSize || '120ml'} scent oil.`);
        this.updateText('[data-scent-subheading]', `Original scent price: ${this.state.paidPrice || ''}. ${this.state.deviceTitle || 'Your diffuser'} stays free with this selection.`);
        this.updateText('[data-route-pill-device]', `${this.state.deviceTitle || ''} route`);
        this.updateText('[data-route-pill-price]', this.state.paidPrice || '');
        this.updateText('[data-review-device]', this.state.deviceTitle);
        this.updateText('[data-review-color]', this.state.colorTitle || '');
        this.updateText('[data-review-value]', this.state.freeValue || '');
        this.updateText('[data-review-scent]', this.state.scentTitle ? `${this.state.scentTitle} ${this.state.requiredSize}` : `Choose a ${this.state.requiredSize || '120ml'} scent oil`);
        this.updateText('[data-review-notes]', this.state.scentNotes || 'Choose a scent from step 2.');
        this.updateText('[data-review-price]', this.state.scentPrice || this.state.paidPrice || '');
        this.updateText('[data-review-total]', this.state.scentPrice || this.state.paidPrice || '');
        this.querySelectorAll('[data-slide-next="review"]').forEach((button) => {
          button.disabled = !ready;
        });
        if (this.submitButton) this.submitButton.disabled = !ready;
        if (this.message) {
          this.message.textContent = ready
            ? `${this.state.scentTitle} ${this.state.requiredSize} selected. Review your free ${this.state.deviceTitle}.`
            : `Choose a ${this.state.requiredSize || '120ml'} scent oil to unlock the free diffuser.`;
        }
      }

      updateText(selector, value) {
        this.querySelectorAll(selector).forEach((element) => {
          element.textContent = value || '';
        });
      }

      setupCountdown() {
        if (!this.countdowns.length) return;
        this.offerStart = Date.parse(this.dataset.offerStart || '');
        this.offerEnd = Date.parse(this.dataset.offerEnd || '');
        if (Number.isNaN(this.offerStart) || Number.isNaN(this.offerEnd)) return;
        this.updateCountdown();
        this.countdownTimer = window.setInterval(() => this.updateCountdown(), 1000);
      }

      updateCountdown() {
        const now = Date.now();
        let target = this.offerStart;
        let label = 'Offer opens in';
        let windowLabel = 'Official event opens June 28';
        let status = 'upcoming';
        let ended = false;
        if (now >= this.offerStart && now <= this.offerEnd) {
          target = this.offerEnd;
          label = 'Offer ends in';
          windowLabel = 'June 28 - July 10';
          status = 'live';
        } else if (now > this.offerEnd) {
          target = now;
          label = 'Offer ended';
          windowLabel = 'Event ended July 10';
          status = 'ended';
          ended = true;
        }
        const remaining = Math.max(0, target - now);
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        this.updateText('[data-countdown-label]', label);
        this.updateText('[data-countdown-window]', windowLabel);
        this.updateText('[data-countdown-days]', this.pad(days));
        this.updateText('[data-countdown-hours]', this.pad(hours));
        this.updateText('[data-countdown-minutes]', this.pad(minutes));
        this.updateText('[data-countdown-seconds]', this.pad(seconds));
        this.countdowns.forEach((countdown) => {
          countdown.dataset.expired = ended ? 'true' : 'false';
          countdown.dataset.status = status;
        });
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }

      addOffer() {
        if (!this.state.diffuserVariant || !this.state.scentVariant || !this.submitButton) return;
        const root = window.Shopify?.routes?.root || '/';
        const themeRoutes = window.routes || window.theme?.routes || {};
        const cartAddUrl = `${root}cart/add.js`.replace('//', '/');
        const cartUrl = themeRoutes.cart_url || `${root}cart`.replace('//', '/');
        const offerCartUrl = `${cartUrl}${cartUrl.includes('?') ? '&' : '?'}july_offer=1`;
        const body = JSON.stringify({
          items: [
            {
              id: Number(this.state.scentVariant),
              quantity: 1,
              properties: {
                '_Offer': '4th of July Scent Event',
                'Required scent size': this.state.requiredSize,
                'Paired free diffuser': this.state.deviceTitle
              }
            },
            {
              id: Number(this.state.diffuserVariant),
              quantity: 1,
              properties: {
                '_Offer': '4th of July Scent Event',
                'Free diffuser': this.state.deviceTitle,
                'Color': this.state.colorTitle
              }
            }
          ]
        });
        const config = window.fetchConfig
          ? window.fetchConfig('javascript')
          : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
        config.method = 'POST';
        config.headers = config.headers || {};
        config.headers['Content-Type'] = 'application/json';
        config.headers['Accept'] = 'application/json';
        config.body = body;
        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.suppressCompetingCarts();
        if (this.message) this.message.textContent = 'Adding your offer...';
        let added = false;
        fetch(cartAddUrl, config)
          .then(async (response) => {
            const payload = await response.json().catch(() => ({}));
            if (!response.ok || payload.status) {
              throw new Error(this.normalizeCartError(payload));
            }
            return payload;
          })
          .then((response) => {
            added = true;
            this.suppressCompetingCarts();
            this.submitButton.classList.remove('loading');
            this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Opening cart...'));
            if (this.message) this.message.textContent = 'Offer added. Taking you to cart...';
            try {
              window.sessionStorage.setItem('veronaJulyOfferCart', String(Date.now()));
            } catch (error) {
              // Storage can be unavailable in private browsing; the cart page also checks line item properties.
            }
            window.location.href = offerCartUrl;
            window.setTimeout(() => {
              if (window.location.pathname !== cartUrl) {
                this.submitButton.disabled = false;
                this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Add offer to cart'));
                if (this.message) this.message.textContent = 'Offer added. Open your cart to review it.';
              }
            }, 1200);
          })
          .catch((error) => {
            document.body.classList.remove('july-offer-cart-routing');
            if (this.message) this.message.textContent = error.message || 'Something went wrong. Please try again.';
          })
          .finally(() => {
            if (!added) {
              this.submitButton.classList.remove('loading');
              this.updateReview();
            }
          });
      }

      normalizeCartError(payload = {}) {
        const raw = String(payload.description || payload.message || '').trim();
        if (!raw) return 'This offer could not be added. Please refresh and try again.';
        const lower = raw.toLowerCase();
        if (lower.includes('épuis') || lower.includes('indisponible') || lower.includes('stock') || lower.includes('available')) {
          return 'One of the selected items is unavailable. Please choose another option and try again.';
        }
        if (lower.includes('quantit') || lower.includes('quantity')) {
          return 'The selected quantity is not available. Please refresh and try again.';
        }
        return 'This offer could not be added. Please refresh and try again.';
      }

      suppressCompetingCarts() {
        document.body.classList.add('july-offer-cart-routing');
        document.body.classList.remove('klaviyo-prevent-body-scrolling');
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        document.querySelectorAll('#moonbundle-cart-drawer, #moonbundle-cart-drawer-overlay, moonbundle-cart-drawer-block, .moonbundle-cart-drawer, .moonbundle-cart-drawer-overlay').forEach((element) => {
          element.classList.remove('open', 'active', 'is-open');
          element.setAttribute('aria-hidden', 'true');
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.setProperty('opacity', '0', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["subscription-offer-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscription-offer-builder')) {
    customElements.define('subscription-offer-builder', class SubscriptionOfferBuilder extends HTMLElement {
      connectedCallback() {
        document.body.classList.add('subscription-offer-page');
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.stepButtons = Array.from(this.querySelectorAll('[data-step-target]'));
        this.routeButtons = Array.from(this.querySelectorAll('[data-route-control]'));
        this.deviceVisuals = Array.from(this.querySelectorAll('[data-device-visual]'));
        this.showcaseImages = Array.from(this.querySelectorAll('[data-showcase-src]'));
        this.cardVisuals = Array.from(this.querySelectorAll('[data-card-visual]'));
        this.colorGroups = Array.from(this.querySelectorAll('[data-colors-route]'));
        this.scentGroups = Array.from(this.querySelectorAll('[data-scents-route]'));
        this.upsells = Array.from(this.querySelectorAll('[data-upsell]'));
        this.infoModal = this.querySelector('[data-device-info-modal]');
        this.infoDialog = this.querySelector('[data-device-info-dialog]');
        this.infoTitle = this.querySelector('[data-device-info-title]');
        this.infoPanels = Array.from(this.querySelectorAll('[data-device-info-panel]'));
        this.policyModal = this.querySelector('[data-policy-modal]');
        this.policyDialog = this.querySelector('[data-policy-dialog]');
        this.quizModal = this.querySelector('[data-subscription-quiz-modal]');
        this.quizDialog = this.querySelector('[data-subscription-quiz-dialog]');
        this.quizTitle = this.querySelector('[data-subscription-quiz-title]');
        this.quizEyebrow = this.querySelector('[data-subscription-quiz-eyebrow]');
        this.quizCopy = this.querySelector('[data-subscription-quiz-copy]');
        this.quizBody = this.querySelector('[data-subscription-quiz-body]');
        this.quizMessage = this.querySelector('[data-subscription-quiz-message]');
        this.quizProgress = this.querySelector('[data-subscription-quiz-progress]');
        this.quizBackButton = this.querySelector('[data-subscription-quiz-back]');
        this.quizNextButton = this.querySelector('[data-subscription-quiz-next]');
        this.useSubscriptionQuizResultButton = this.querySelector('[data-use-subscription-quiz-result]');
        this.submitButton = this.querySelector('[data-add-offer]');
        this.messages = Array.from(this.querySelectorAll('[data-offer-message]'));
        this.state = {};
        this.cartSubmissionInFlight = false;
        this.subscriptionQuiz = null;
        this.handleDeviceInfoKeydown = this.handleDeviceInfoKeydown.bind(this);
        this.handlePolicyKeydown = this.handlePolicyKeydown.bind(this);
        this.handleSubscriptionQuizKeydown = this.handleSubscriptionQuizKeydown.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleShowcaseMediaChange = this.handleShowcaseMediaChange.bind(this);
        this.setupShowcaseImageLoading();
        this.stepButtons.forEach((button) => button.addEventListener('click', () => this.goTo(button.dataset.stepTarget)));
        this.querySelectorAll('[data-slide-next]').forEach((button) => {
          button.addEventListener('click', () => this.goTo(button.dataset.slideNext));
        });
        this.querySelectorAll('[data-slide-prev]').forEach((button) => {
          button.addEventListener('click', () => this.goTo(button.dataset.slidePrev));
        });
        this.routeButtons.forEach((button) => button.addEventListener('click', () => {
          this.clearQuizFlow();
          this.setRoute(button.dataset.route);
        }));
        this.querySelectorAll('[data-device-info]').forEach((button) => {
          button.addEventListener('click', () => this.openDeviceInfo(button.dataset.deviceInfo, button));
        });
        this.querySelectorAll('[data-device-info-current]').forEach((button) => {
          button.addEventListener('click', () => this.openDeviceInfo(this.state.route || this.dataset.activeRoute || 'benz', button));
        });
        this.querySelectorAll('[data-device-info-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeDeviceInfo());
        });
        this.querySelector('[data-device-info-continue]')?.addEventListener('click', () => {
          if (this.infoRoute) this.setRoute(this.infoRoute);
          this.closeDeviceInfo();
        });
        this.querySelectorAll('[data-policy-info]').forEach((button) => {
          button.addEventListener('click', () => this.openPolicy(button));
        });
        this.querySelectorAll('[data-policy-close]').forEach((button) => {
          button.addEventListener('click', () => this.closePolicy());
        });
        this.querySelectorAll('[data-open-scent-quiz]').forEach((button) => {
          button.addEventListener('click', () => this.openSubscriptionQuiz('scent', button));
        });
        this.querySelectorAll('[data-open-device-quiz]').forEach((button) => {
          button.addEventListener('click', () => this.openSubscriptionQuiz('device', button));
        });
        this.querySelectorAll('[data-subscription-quiz-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeSubscriptionQuiz());
        });
        this.quizBody?.addEventListener('click', (event) => {
          const option = event.target.closest('[data-subscription-quiz-option]');
          if (option) this.selectSubscriptionQuizOption(Number(option.dataset.subscriptionQuizOption));
        });
        this.quizBackButton?.addEventListener('click', () => this.backSubscriptionQuiz());
        this.quizNextButton?.addEventListener('click', () => this.nextSubscriptionQuiz());
        this.useSubscriptionQuizResultButton?.addEventListener('click', () => this.useSubscriptionQuizResult());
        this.querySelectorAll('[data-diffuser-variant]').forEach((button) => {
          button.addEventListener('click', () => this.selectDiffuser(button));
        });
        this.querySelectorAll('[data-scent-variant]').forEach((button) => {
          button.addEventListener('click', () => this.selectScent(button));
        });
        this.querySelectorAll('[data-upgrade-route]').forEach((button) => {
          button.addEventListener('click', () => {
            this.clearQuizFlow();
            this.setRoute(button.dataset.upgradeRoute);
            this.goTo('scent');
          });
        });
        this.submitButton?.addEventListener('click', () => this.addOffer());
        this.setRoute(this.dataset.activeRoute || 'benz');
        if (!this.applyQuizParams()) this.goTo('device', false);
        document.addEventListener('keydown', this.handleDeviceInfoKeydown);
        document.addEventListener('keydown', this.handlePolicyKeydown);
        document.addEventListener('keydown', this.handleSubscriptionQuizKeydown);
        window.addEventListener('pageshow', this.handlePageShow);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.setupScrollLockRecovery();
      }

      disconnectedCallback() {
        document.body.classList.remove('subscription-offer-page');
        document.body.classList.remove('subscription-offer-info-open');
        document.body.classList.remove('subscription-offer-cart-routing');
        if (this.handleDeviceInfoKeydown) document.removeEventListener('keydown', this.handleDeviceInfoKeydown);
        if (this.handlePolicyKeydown) document.removeEventListener('keydown', this.handlePolicyKeydown);
        if (this.handleSubscriptionQuizKeydown) document.removeEventListener('keydown', this.handleSubscriptionQuizKeydown);
        if (this.handlePageShow) window.removeEventListener('pageshow', this.handlePageShow);
        if (this.handleVisibilityChange) document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.scrollLockObserver) this.scrollLockObserver.disconnect();
        if (this.scrollLockReconcileTimer) window.clearTimeout(this.scrollLockReconcileTimer);
        if (this.showcaseMediaQuery && this.handleShowcaseMediaChange) {
          if (typeof this.showcaseMediaQuery.removeEventListener === 'function') {
            this.showcaseMediaQuery.removeEventListener('change', this.handleShowcaseMediaChange);
          } else if (typeof this.showcaseMediaQuery.removeListener === 'function') {
            this.showcaseMediaQuery.removeListener(this.handleShowcaseMediaChange);
          }
        }
      }

      setupShowcaseImageLoading() {
        if (!this.showcaseImages?.length || !window.matchMedia) return;
        this.showcaseMediaQuery = window.matchMedia('(min-width: 750px)');
        this.handleShowcaseMediaChange();
        if (typeof this.showcaseMediaQuery.addEventListener === 'function') {
          this.showcaseMediaQuery.addEventListener('change', this.handleShowcaseMediaChange);
        } else if (typeof this.showcaseMediaQuery.addListener === 'function') {
          this.showcaseMediaQuery.addListener(this.handleShowcaseMediaChange);
        }
      }

      handleShowcaseMediaChange() {
        if (!this.showcaseMediaQuery?.matches) return;
        const activeImages = this.showcaseImages.filter((image) => image.closest('[data-device-visual]')?.classList.contains('is-active'));
        activeImages.forEach((image) => this.loadShowcaseImage(image));
        const deferredImages = this.showcaseImages.filter((image) => !activeImages.includes(image));
        const loadDeferred = () => {
          if (!this.isConnected) return;
          deferredImages.forEach((image) => this.loadShowcaseImage(image));
        };
        if (window.requestIdleCallback) {
          window.requestIdleCallback(loadDeferred, { timeout: 1600 });
        } else {
          window.setTimeout(loadDeferred, 500);
        }
      }

      loadShowcaseImage(image) {
        if (!this.isConnected) return;
        const src = image?.dataset?.showcaseSrc;
        if (!src || image.dataset.loadedShowcase === 'true') return;
        image.src = src;
        image.dataset.loadedShowcase = 'true';
      }

      setRoute(route) {
        const routeButton = this.routeButtons.find((button) => button.dataset.route === route);
        if (!routeButton) return;
        this.dataset.activeRoute = route;
        this.state.route = route;
        this.state.deviceTitle = routeButton.dataset.deviceTitle || '';
        this.state.requiredSize = routeButton.dataset.requiredSize || '';
        this.state.paidPrice = routeButton.dataset.paidPrice || '';
        this.state.paidPriceCents = routeButton.dataset.paidPriceCents || '';
        this.state.freeValue = routeButton.dataset.freeValue || '';
        this.state.visualCopy = routeButton.dataset.routeVisualCopy || '';
        this.state.scentVariant = '';
        this.state.scentTitle = '';
        this.state.scentPrice = '';
        this.state.scentPriceCents = '';
        this.state.scentNotes = '';
        this.state.sellingPlan = '';
        this.state.sellingPlanName = '';
        this.routeButtons.forEach((button) => {
          const active = button.dataset.route === route;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          button.closest('[data-route-card]')?.classList.toggle('is-active', active);
        });
        this.colorGroups.forEach((group) => {
          const active = group.dataset.colorsRoute === route;
          group.hidden = !active;
          group.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.scentGroups.forEach((group) => {
          const active = group.dataset.scentsRoute === route;
          group.hidden = !active;
          group.setAttribute('aria-hidden', active ? 'false' : 'true');
          group.querySelectorAll('[data-scent-variant]').forEach((card) => card.classList.remove('is-active'));
        });
        this.upsells.forEach((upsell) => {
          const active = upsell.dataset.upsell === route;
          upsell.hidden = !active;
        });
        const activeColor = this.querySelector(`[data-colors-route="${route}"] [data-diffuser-variant].is-active:not([disabled])`)
          || this.querySelector(`[data-colors-route="${route}"] [data-diffuser-variant]:not([disabled])`);
        if (activeColor) this.selectDiffuser(activeColor);
        if (this.currentSlide === 'review') this.goTo('scent');
        this.updateQuizAssistLink();
        this.updateReview();
      }

      openDeviceInfo(route, trigger) {
        if (!this.infoModal || !this.infoDialog) return;
        const selectedRoute = route || this.state.route || this.dataset.activeRoute || 'benz';
        const activePanel = this.infoPanels.find((panel) => panel.dataset.deviceInfoPanel === selectedRoute);
        if (!activePanel) return;
        this.infoRoute = selectedRoute;
        this.infoTrigger = trigger || document.activeElement;
        this.infoPanels.forEach((panel) => {
          const active = panel === activePanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (this.infoTitle) this.infoTitle.textContent = activePanel.dataset.deviceInfoTitle || 'Device details';
        this.infoModal.hidden = false;
        document.body.classList.add('subscription-offer-info-open');
        window.requestAnimationFrame(() => {
          this.infoDialog.focus({ preventScroll: true });
        });
      }

      closeDeviceInfo(returnFocus = true) {
        if (!this.infoModal || this.infoModal.hidden) return;
        this.infoModal.hidden = true;
        document.body.classList.remove('subscription-offer-info-open');
        const focusTarget = this.infoTrigger;
        this.infoTrigger = null;
        if (returnFocus && focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }

      openPolicy(trigger) {
        if (!this.policyModal || !this.policyDialog) return;
        this.policyTrigger = trigger || document.activeElement;
        this.policyModal.hidden = false;
        document.body.classList.add('subscription-offer-info-open');
        window.requestAnimationFrame(() => {
          this.policyDialog.focus({ preventScroll: true });
        });
      }

      closePolicy(returnFocus = true) {
        if (!this.policyModal || this.policyModal.hidden) return;
        this.policyModal.hidden = true;
        document.body.classList.remove('subscription-offer-info-open');
        const focusTarget = this.policyTrigger;
        this.policyTrigger = null;
        if (returnFocus && focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }

      openSubscriptionQuiz(type, trigger) {
        if (!this.quizModal || !this.quizDialog || !this.quizBody) return;
        const questions = this.getSubscriptionQuizQuestions(type);
        if (!questions.length) return;
        this.subscriptionQuiz = {
          type,
          questions,
          step: 0,
          answers: {},
          result: null
        };
        this.quizTrigger = trigger || document.activeElement;
        this.quizModal.hidden = false;
        document.body.classList.add('subscription-offer-info-open');
        this.renderSubscriptionQuiz();
        window.requestAnimationFrame(() => {
          this.quizDialog.focus({ preventScroll: true });
        });
      }

      closeSubscriptionQuiz(returnFocus = true) {
        if (!this.quizModal || this.quizModal.hidden) return;
        this.quizModal.hidden = true;
        document.body.classList.remove('subscription-offer-info-open');
        this.subscriptionQuiz = null;
        const focusTarget = this.quizTrigger;
        this.quizTrigger = null;
        if (returnFocus && focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }

      handleSubscriptionQuizKeydown(event) {
        if (!this.quizModal || this.quizModal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeSubscriptionQuiz();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.quizModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.disabled && !element.hidden && element.offsetParent !== null && !element.classList.contains('subscription-offer__spec-backdrop'));
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      getSubscriptionQuizQuestions(type) {
        if (type === 'device') {
          return [
            {
              id: 'space',
              eyebrow: 'Space guide',
              title: 'Where will you use your diffuser most?',
              options: [
                { label: 'Car or desk', detail: 'A polished scent close to you.', routes: { benz: 6, whisper: 1 } },
                { label: 'Bedroom or office', detail: 'Quiet scenting for a defined room.', routes: { whisper: 6, benz: 1 } },
                { label: 'Living room', detail: 'A balanced scent for everyday hosting.', routes: { aura: 5, whisper: 2 } },
                { label: 'Whole home', detail: 'A signature atmosphere across multiple areas.', routes: { grand: 6, aura: 2 } },
                { label: 'Store or showroom', detail: 'A memorable welcome for guests.', routes: { aura: 5, grand: 3 } }
              ]
            },
            {
              id: 'coverage',
              eyebrow: 'Coverage',
              title: 'How large is the scenting area?',
              options: [
                { label: 'Compact', detail: 'Car, desk, small office, or personal corner.', routes: { benz: 5, whisper: 1 } },
                { label: 'One room', detail: 'Bedroom, office, or medium everyday room.', routes: { whisper: 5, aura: 1 } },
                { label: 'Open area', detail: 'Living room, reception, or larger suite.', routes: { aura: 5, grand: 1 } },
                { label: 'Multi-room / HVAC', detail: 'Large apartment, villa, or connected airflow.', routes: { grand: 6, aura: 1 } }
              ]
            },
            {
              id: 'presence',
              eyebrow: 'Presence',
              title: 'How present should the fragrance feel?',
              options: [
                { label: 'Soft', detail: 'A quiet scent in the background.', routes: { whisper: 3, benz: 2, aura: 1 } },
                { label: 'Balanced', detail: 'Noticeable when you enter, never too much.', routes: { aura: 3, whisper: 2 } },
                { label: 'Signature', detail: 'A clear Verona atmosphere with more coverage.', routes: { grand: 4, aura: 2 } }
              ]
            }
          ];
        }
        return [
          {
            id: 'mood',
            eyebrow: 'Scent mood',
            title: 'What should the room feel like?',
            options: [
              { label: 'Clean and airy', detail: 'Fresh, clear, and easy to live with.', weights: { fresh: 3, green: 1, calm: 1 }, boosts: { hope: 6, 'shangri-la': 3, amar: 2, 'sea-front': 1 } },
              { label: 'Luxury hotel lobby', detail: 'Elegant, memorable, and elevated.', weights: { luxury: 3, floral: 1, woody: 1 }, boosts: { 'my-way': 5, 'shangri-la': 4, santale: 3, 'square-gather': 2 } },
              { label: 'Calm spa', detail: 'Quiet, botanical, and restorative.', weights: { spa: 3, herbal: 1, calm: 1 }, boosts: { 'spa-now': 5, amar: 4, hope: 2, 'shangri-la': 1 } },
              { label: 'Bright and energizing', detail: 'Crisp lift with a refined finish.', weights: { citrus: 3, energy: 2, fresh: 1 }, boosts: { lemongrass: 6, hope: 5, 'exotic-tea': 4, 'square-gather': 2 } },
              { label: 'Warm and sensual', detail: 'Soft woods, musk, and evening depth.', weights: { warm: 3, woody: 2, luxury: 1 }, boosts: { santale: 5, 'my-way': 3, amar: 2 } },
              { label: 'Coastal and fresh', detail: 'Airy, aquatic, and breezy.', weights: { aquatic: 3, fresh: 2, calm: 1 }, boosts: { 'sea-front': 6, hope: 2, 'shangri-la': 1 } }
            ]
          },
          {
            id: 'notes',
            eyebrow: 'Favorite notes',
            title: 'Which notes do you naturally like?',
            options: [
              { label: 'Citrus', detail: 'Bergamot, lime, lemon, orange.', weights: { citrus: 4, fresh: 1, energy: 1 }, boosts: { lemongrass: 8, 'square-gather': 4, 'exotic-tea': 3, hope: 2 } },
              { label: 'White florals', detail: 'Jasmine, tuberose, peony, muguet.', weights: { floral: 4, luxury: 2 }, boosts: { 'my-way': 6, 'shangri-la': 4, 'square-gather': 2 } },
              { label: 'Green tea & bamboo', detail: 'Leafy, modern, and quietly clean.', weights: { green: 4, fresh: 2 }, boosts: { amar: 6, 'exotic-tea': 5, 'shangri-la': 4, hope: 2 } },
              { label: 'Sea salt', detail: 'Marine air with a soft mineral edge.', weights: { aquatic: 4, fresh: 2 }, boosts: { 'sea-front': 7 } },
              { label: 'Herbs', detail: 'Lavender, basil, rosemary, eucalyptus.', weights: { herbal: 4, spa: 2 }, boosts: { 'spa-now': 6, hope: 5, amar: 2 } },
              { label: 'Sandalwood & musk', detail: 'Smooth, warm, and long-lasting.', weights: { woody: 4, warm: 2 }, boosts: { santale: 7, amar: 3, 'my-way': 2 } }
            ]
          },
          {
            id: 'avoid',
            eyebrow: 'Preference check',
            title: 'Anything you usually avoid?',
            options: [
              { label: 'Skip sweet notes', detail: 'Keep it polished and not sugary.', weights: { warm: -2, floral: -1, fresh: 1, green: 1 }, penalties: { 'my-way': -2, santale: -2 } },
              { label: 'Skip heavy florals', detail: 'Less bouquet, more atmosphere.', weights: { floral: -3, woody: 1, green: 1 }, penalties: { 'my-way': -5 } },
              { label: 'Skip herbal spa', detail: 'Avoid a strongly botanical profile.', weights: { herbal: -3, fresh: 1, luxury: 1 }, penalties: { 'spa-now': -5 } },
              { label: 'Skip dense woods', detail: 'Keep woods soft and balanced.', weights: { woody: -3, fresh: 1, floral: 1 }, penalties: { santale: -5 } },
              { label: 'Skip aquatic notes', detail: 'Avoid a marine-forward profile.', weights: { aquatic: -3, warm: 1, woody: 1 }, penalties: { 'sea-front': -5 } },
              { label: 'No strong avoid', detail: 'Open to the best Verona match.', weights: { fresh: 1, calm: 1 } }
            ]
          }
        ];
      }

      renderSubscriptionQuiz() {
        if (!this.subscriptionQuiz || !this.quizBody) return;
        const session = this.subscriptionQuiz;
        const isResult = session.step >= session.questions.length;
        const label = session.type === 'device' ? 'Diffuser guide' : 'Scent guide';
        const headline = session.type === 'device' ? 'Find your diffuser fit' : 'Find your scent';
        const copy = session.type === 'device'
          ? 'Three quick questions to match coverage, room size, and scent presence.'
          : 'Three scent-only questions for this monthly plan. No device detour.';
        if (this.quizEyebrow) this.quizEyebrow.textContent = label;
        if (this.quizTitle) this.quizTitle.textContent = headline;
        if (this.quizCopy) this.quizCopy.textContent = copy;
        if (this.quizMessage) this.quizMessage.textContent = '';
        if (this.quizProgress) {
          const progress = isResult ? 100 : Math.round((session.step / session.questions.length) * 100);
          this.quizProgress.style.width = `${progress}%`;
        }
        if (this.quizBackButton) this.quizBackButton.hidden = session.step === 0;
        if (this.quizNextButton) {
          this.quizNextButton.hidden = true;
          this.quizNextButton.disabled = true;
        }
        if (this.useSubscriptionQuizResultButton) {
          this.useSubscriptionQuizResultButton.hidden = !isResult;
          this.useSubscriptionQuizResultButton.disabled = true;
          this.useSubscriptionQuizResultButton.textContent = session.type === 'device' ? 'Select this diffuser' : 'Select this scent';
          this.useSubscriptionQuizResultButton.toggleAttribute('data-use-device-result', isResult && session.type === 'device');
          this.useSubscriptionQuizResultButton.toggleAttribute('data-use-scent-result', isResult && session.type === 'scent');
        }
        if (isResult) {
          this.renderSubscriptionQuizResult();
          return;
        }
        const question = session.questions[session.step];
        const selected = session.answers[question.id];
        this.quizBody.innerHTML = `
          <div class="subscription-offer__quiz-question">
            <span>${this.escapeHtml(question.eyebrow)}</span>
            <h3>${this.escapeHtml(question.title)}</h3>
            <div class="subscription-offer__quiz-options">
              ${question.options.map((option, index) => `
                <button type="button" class="subscription-offer__quiz-option${selected === index ? ' is-selected' : ''}" data-subscription-quiz-option="${index}" aria-pressed="${selected === index ? 'true' : 'false'}">
                  <strong>${this.escapeHtml(option.label)}</strong>
                  <small>${this.escapeHtml(option.detail)}</small>
                </button>
              `).join('')}
            </div>
          </div>
        `;
      }

      renderSubscriptionQuizResult() {
        if (!this.subscriptionQuiz || !this.quizBody) return;
        const result = this.subscriptionQuiz.type === 'device'
          ? this.getDeviceQuizResult()
          : this.getScentQuizResult();
        this.subscriptionQuiz.result = result;
        if (!result) {
          this.quizBody.innerHTML = `
            <div class="subscription-offer__quiz-result">
              <span>Almost there</span>
              <h3>Choose from the options on this page.</h3>
              <p>We could not find a complete match with the current availability, but the manual builder is ready below.</p>
            </div>
          `;
          if (this.quizMessage) this.quizMessage.textContent = 'Please choose manually from the available options.';
          if (this.useSubscriptionQuizResultButton) this.useSubscriptionQuizResultButton.disabled = true;
          return;
        }
        if (this.useSubscriptionQuizResultButton) this.useSubscriptionQuizResultButton.disabled = false;
        this.quizBody.innerHTML = `
          <div class="subscription-offer__quiz-result">
            <span>Your Verona match</span>
            <h3>${this.escapeHtml(result.title)}</h3>
            <p>${this.escapeHtml(result.reason)}</p>
          </div>
        `;
      }

      selectSubscriptionQuizOption(index) {
        if (!this.subscriptionQuiz) return;
        const currentStep = this.subscriptionQuiz.step;
        const question = this.subscriptionQuiz.questions[this.subscriptionQuiz.step];
        if (!question || !question.options[index]) return;
        this.subscriptionQuiz.answers[question.id] = index;
        this.renderSubscriptionQuiz();
        window.setTimeout(() => {
          if (!this.subscriptionQuiz || this.subscriptionQuiz.step !== currentStep) return;
          this.subscriptionQuiz.step += 1;
          this.renderSubscriptionQuiz();
        }, 140);
      }

      useSubscriptionQuizResult() {
        if (!this.subscriptionQuiz) return;
        if (this.subscriptionQuiz.type === 'device') {
          this.useDeviceQuizResult();
          return;
        }
        this.useScentQuizResult();
      }

      hasSubscriptionQuizAnswer() {
        if (!this.subscriptionQuiz) return false;
        const question = this.subscriptionQuiz.questions[this.subscriptionQuiz.step];
        return Boolean(question && typeof this.subscriptionQuiz.answers[question.id] === 'number');
      }

      nextSubscriptionQuiz() {
        if (!this.subscriptionQuiz || !this.hasSubscriptionQuizAnswer()) return;
        this.subscriptionQuiz.step += 1;
        this.renderSubscriptionQuiz();
      }

      backSubscriptionQuiz() {
        if (!this.subscriptionQuiz || this.subscriptionQuiz.step <= 0) return;
        this.subscriptionQuiz.step -= 1;
        this.renderSubscriptionQuiz();
      }

      getSelectedSubscriptionQuizOptions() {
        if (!this.subscriptionQuiz) return [];
        return this.subscriptionQuiz.questions.map((question) => {
          const index = this.subscriptionQuiz.answers[question.id];
          return typeof index === 'number' ? question.options[index] : null;
        }).filter(Boolean);
      }

      getDeviceQuizResult() {
        const scores = { benz: 0, whisper: 0, aura: 0, grand: 0 };
        this.getSelectedSubscriptionQuizOptions().forEach((option) => {
          Object.entries(option.routes || {}).forEach(([route, value]) => {
            scores[route] = (scores[route] || 0) + Number(value || 0);
          });
        });
        const ordered = Object.entries(scores).sort((a, b) => b[1] - a[1]);
        const route = ordered[0]?.[0] || 'whisper';
        const button = this.routeButtons.find((item) => item.dataset.route === route) || this.routeButtons[0];
        if (!button) return null;
        return {
          route,
          title: button.dataset.deviceTitle || this.toTitleCase(route),
          reason: this.getDeviceQuizReason(route)
        };
      }

      getDeviceQuizReason(route) {
        const reasons = {
          benz: 'A refined choice for close-range scenting in cars, desks, and compact personal spaces.',
          whisper: 'Quiet, polished coverage for bedrooms, offices, and everyday rooms without overpowering the space.',
          aura: 'A stronger fit for open living areas and larger rooms where Verona should feel present and balanced.',
          grand: 'Built for larger spaces, multi-room scenting, and whole-home or HVAC-ready coverage.'
        };
        return reasons[route] || reasons.whisper;
      }

      getScentQuizResult() {
        const route = this.state.route || this.dataset.activeRoute || 'benz';
        const availableButtons = Array.from(this.querySelectorAll(`[data-scents-route="${route}"] [data-scent-variant]:not([disabled])`))
          .filter((button) => Boolean(button.dataset.sellingPlan));
        if (!availableButtons.length) return null;
        const weights = {};
        const directScores = {};
        this.getSelectedSubscriptionQuizOptions().forEach((option) => {
          Object.entries(option.weights || {}).forEach(([key, value]) => {
            weights[key] = (weights[key] || 0) + Number(value || 0);
          });
          [option.boosts, option.penalties].forEach((map) => {
            Object.entries(map || {}).forEach(([handle, value]) => {
              directScores[handle] = (directScores[handle] || 0) + Number(value || 0);
            });
          });
        });
        const profiles = this.getScentProfiles();
        const ranked = availableButtons.map((button) => {
          const handle = this.normalizeHandle(button.dataset.scentHandle);
          const profile = profiles[handle] || {};
          const profileScore = Object.entries(weights).reduce((total, [key, value]) => {
            return total + Number(value || 0) * Number(profile[key] || 0);
          }, 0);
          return {
            button,
            handle,
            score: profileScore + Number(directScores[handle] || 0)
          };
        }).sort((a, b) => b.score - a.score);
        const best = ranked[0];
        if (!best) return null;
        return {
          button: best.button,
          handle: best.handle,
          title: best.button.dataset.scentTitle || 'Your Verona scent',
          reason: this.getScentQuizReason(best.handle)
        };
      }

      getScentProfiles() {
        return {
          'my-way': { fresh: 2, citrus: 1, green: 0, floral: 7, woody: 3, aquatic: 0, herbal: 0, warm: 3, spa: 1, luxury: 7, energy: 2, calm: 2, hosting: 6 },
          hope: { fresh: 7, citrus: 3, green: 5, floral: 1, woody: 2, aquatic: 1, herbal: 5, warm: 0, spa: 4, luxury: 2, energy: 6, calm: 6, hosting: 1 },
          lemongrass: { fresh: 6, citrus: 9, green: 3, floral: 2, woody: 1, aquatic: 0, herbal: 2, warm: 0, spa: 2, luxury: 1, energy: 8, calm: 1, hosting: 1 },
          'spa-now': { fresh: 3, citrus: 0, green: 5, floral: 2, woody: 3, aquatic: 0, herbal: 8, warm: 2, spa: 8, luxury: 2, energy: 1, calm: 8, hosting: 1 },
          'sea-front': { fresh: 6, citrus: 1, green: 2, floral: 2, woody: 2, aquatic: 8, herbal: 0, warm: 1, spa: 2, luxury: 2, energy: 2, calm: 5, hosting: 2 },
          'shangri-la': { fresh: 4, citrus: 2, green: 5, floral: 5, woody: 2, aquatic: 1, herbal: 1, warm: 1, spa: 3, luxury: 5, energy: 2, calm: 5, hosting: 3 },
          'exotic-tea': { fresh: 6, citrus: 7, green: 7, floral: 1, woody: 2, aquatic: 0, herbal: 4, warm: 0, spa: 2, luxury: 2, energy: 6, calm: 2, hosting: 1 },
          'square-gather': { fresh: 4, citrus: 6, green: 1, floral: 3, woody: 3, aquatic: 0, herbal: 0, warm: 2, spa: 1, luxury: 5, energy: 5, calm: 1, hosting: 5 },
          santale: { fresh: 1, citrus: 0, green: 1, floral: 2, woody: 7, aquatic: 0, herbal: 1, warm: 7, spa: 2, luxury: 6, energy: 1, calm: 5, hosting: 5 },
          amar: { fresh: 4, citrus: 1, green: 7, floral: 2, woody: 5, aquatic: 0, herbal: 2, warm: 2, spa: 5, luxury: 3, energy: 2, calm: 7, hosting: 2 }
        };
      }

      getScentQuizReason(handle) {
        const reasons = {
          'my-way': 'Radiant florals and smooth woods create a polished hotel-signature mood.',
          hope: 'Fresh green brightness keeps the room clean, clear, and easy to live with.',
          lemongrass: 'Crisp citrus and garden freshness bring a bright everyday lift.',
          'spa-now': 'Botanical herbs and soft woods create a calm spa-like atmosphere.',
          'sea-front': 'Sea salt and aquatic freshness give the room an airy coastal feel.',
          'shangri-la': 'White tea, pear, and soft florals feel refined without becoming heavy.',
          'exotic-tea': 'Green citrus, bamboo, and tea notes keep the atmosphere modern and bright.',
          'square-gather': 'Sparkling citrus and warm woods bring a welcoming hosting signature.',
          santale: 'Smooth sandalwood, cardamom, and musk create a warm refined signature.',
          amar: 'Bamboo, green tea, and soft woods make the space feel calm and quietly luxurious.'
        };
        return reasons[handle] || 'A Verona scent profile matched to your preferences.';
      }

      useScentQuizResult() {
        const result = this.subscriptionQuiz?.result || this.getScentQuizResult();
        if (!result?.button) {
          if (this.quizMessage) this.quizMessage.textContent = 'This matched scent is not available for the selected plan right now. Please choose another scent below.';
          return;
        }
        this.selectScent(result.button);
        this.closeSubscriptionQuiz();
        this.revealSelectedCard(result.button);
        this.setOfferMessage(`${result.title} selected. Review your offer when you are ready.`);
      }

      useDeviceQuizResult() {
        const result = this.subscriptionQuiz?.result || this.getDeviceQuizResult();
        if (!result?.route) return;
        this.clearQuizFlow();
        this.setRoute(result.route);
        this.closeSubscriptionQuiz();
        this.goTo('device', false);
        const selectedRoute = this.routeButtons.find((button) => button.dataset.route === result.route);
        this.revealSelectedCard(selectedRoute?.closest('[data-route-card]') || selectedRoute);
      }

      revealSelectedCard(element) {
        if (!element || typeof element.scrollIntoView !== 'function') return;
        window.requestAnimationFrame(() => {
          const useSmoothScroll = !window.matchMedia || !window.matchMedia('(max-width: 749px)').matches;
          element.scrollIntoView({ block: 'nearest', inline: 'center', behavior: useSmoothScroll ? 'smooth' : 'auto' });
        });
      }

      handleDeviceInfoKeydown(event) {
        if (!this.infoModal || this.infoModal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeDeviceInfo();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.infoModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.disabled && !element.hidden && element.offsetParent !== null && !element.classList.contains('subscription-offer__spec-backdrop'));
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handlePolicyKeydown(event) {
        if (!this.policyModal || this.policyModal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closePolicy();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.policyModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.disabled && !element.hidden && element.offsetParent !== null && !element.classList.contains('subscription-offer__spec-backdrop'));
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handlePageShow() {
        document.body.classList.remove('subscription-offer-cart-routing');
        this.cartFallbackStarted = false;
        this.moonbundlePresentationActive = false;
        this.scheduleScrollLockReconciliation();
        if (this.cartSubmissionInFlight) return;
        if (!this.submitButton) return;
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Add subscription offer to cart'));
        this.updateReview();
      }

      handleVisibilityChange() {
        if (document.visibilityState === 'visible') this.scheduleScrollLockReconciliation();
      }

      setupScrollLockRecovery() {
        if (!document.body || typeof MutationObserver === 'undefined') return;
        this.scrollLockObserver = new MutationObserver(() => this.scheduleScrollLockReconciliation());
        this.scrollLockObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'aria-modal']
        });
        this.scheduleScrollLockReconciliation();
      }

      scheduleScrollLockReconciliation() {
        if (this.scrollLockReconcileTimer) return;
        this.scrollLockReconcileTimer = window.setTimeout(() => {
          this.scrollLockReconcileTimer = null;
          this.reconcileSubscriptionPageScrollLock();
          this.alignMoonbundleCommitmentCopy();
        }, 120);
      }

      isElementVisible(element) {
        if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
        const styles = window.getComputedStyle(element);
        if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return false;
        const rect = element.getBoundingClientRect();
        return rect.width > 1 && rect.height > 1;
      }

      hasVisibleOverlayOwner() {
        if ([this.infoModal, this.policyModal, this.quizModal].some((element) => this.isElementVisible(element))) return true;
        if (this.moonbundlePresentationActive) return true;
        const moonbundleDrawer = document.querySelector('moonbundle-cart-drawer-block');
        if (moonbundleDrawer && this.isMoonbundleDrawerContentUsable(moonbundleDrawer)) return true;
        const selectors = [
          '#shopify-pc__banner',
          '#shopify-pc__prefs',
          '[data-shopify-customer-privacy]',
          '.shopify-pc__banner__dialog',
          '[role="dialog"][aria-modal="true"]:not(.needsclick)',
          '.shopify-section-popup',
          '.popup-modal',
          '.newsletter-popup',
          '[class*="overlay"][style*="fixed"]',
          '[class*="modal"][style*="fixed"]',
          '[class*="drawer"][style*="fixed"]:not(.moonbundle-cart-drawer)'
        ];
        return selectors.some((selector) => Array.from(document.querySelectorAll(selector)).some((element) => this.isElementVisible(element)));
      }

      hasVisibleKlaviyoSurface() {
        const selectors = [
          '[aria-label="POPUP Form"]',
          '.needsclick[role="dialog"]',
          '[class*="klaviyo"][role="dialog"]',
          '[class*="Klaviyo"][role="dialog"]',
          '[class*="klaviyo"][style*="fixed"]',
          '[class*="Klaviyo"][style*="fixed"]'
        ];
        return selectors.some((selector) => Array.from(document.querySelectorAll(selector)).some((element) => this.isElementVisible(element)));
      }

      reconcileSubscriptionPageScrollLock() {
        const body = document.body;
        const root = document.documentElement;
        if (!body?.classList.contains('subscription-offer-page')) return;
        const hasKlaviyoLock = body.classList.contains('klaviyo-prevent-body-scrolling');
        if (!hasKlaviyoLock || this.hasVisibleKlaviyoSurface() || this.hasVisibleOverlayOwner()) return;
        body.classList.remove('klaviyo-prevent-body-scrolling');
        if (body.style.overflow === 'hidden') body.style.removeProperty('overflow');
        if (root.style.overflow === 'hidden') root.style.removeProperty('overflow');
      }

      selectDiffuser(button) {
        const group = button.closest('[data-colors-route]');
        group?.querySelectorAll('[data-diffuser-variant]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        this.state.diffuserVariant = button.dataset.diffuserVariant;
        this.state.deviceTitle = button.dataset.diffuserTitle || this.state.deviceTitle;
        this.state.colorTitle = button.dataset.colorTitle;
        this.state.colorKey = button.dataset.colorKey || this.normalizeColor(button.dataset.colorTitle);
        this.updateDeviceVisuals();
        this.updateReview();
      }

      updateDeviceVisuals() {
        const route = this.state.route || this.dataset.activeRoute || 'benz';
        const color = this.state.colorKey || '';
        this.deviceVisuals.forEach((visual) => {
          const routeVisuals = this.deviceVisuals.filter((item) => item.dataset.routeVisual === route);
          const fallbackVisual = routeVisuals[0];
          const active = visual.dataset.routeVisual === route && (visual.dataset.colorKey === color || (!routeVisuals.some((item) => item.dataset.colorKey === color) && visual === fallbackVisual));
          visual.classList.toggle('is-active', active);
          if (active && this.showcaseMediaQuery?.matches) this.loadShowcaseImage(visual.querySelector('[data-showcase-src]'));
        });
        this.cardVisuals.forEach((visual) => {
          const visualRoute = visual.dataset.routeVisual || '';
          const defaultColor = visualRoute === 'aura' ? 'black' : 'black';
          const desiredColor = visualRoute === route ? color : defaultColor;
          const routeVisuals = this.cardVisuals.filter((item) => item.dataset.routeVisual === visualRoute);
          const fallbackVisual = routeVisuals.find((item) => item.dataset.colorKey === defaultColor) || routeVisuals[0];
          const hasDesiredColor = routeVisuals.some((item) => item.dataset.colorKey === desiredColor);
          const active = visual.dataset.colorKey === desiredColor || (!hasDesiredColor && visual === fallbackVisual);
          visual.classList.toggle('is-active', active);
        });
      }

      normalizeColor(value = '') {
        const color = value.toLowerCase().trim();
        if (color.includes('grey')) return 'gray';
        if (color.includes('gray')) return 'gray';
        if (color.includes('silver')) return 'gray';
        if (color.includes('white')) return 'white';
        return 'black';
      }

      selectScent(button) {
        const group = button.closest('[data-scents-route]');
        group?.querySelectorAll('[data-scent-variant]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        this.state.scentVariant = button.dataset.scentVariant;
        this.state.scentTitle = button.dataset.scentTitle;
        this.state.scentPrice = button.dataset.scentPrice;
        this.state.scentPriceCents = button.dataset.scentPriceCents || '';
        this.state.requiredSize = button.dataset.scentSize;
        this.state.scentNotes = button.dataset.scentNotes;
        this.state.sellingPlan = button.dataset.sellingPlan || '';
        this.state.sellingPlanName = button.dataset.sellingPlanName || '';
        this.updateReview();
      }

      applyQuizParams() {
        let params;
        try {
          params = new URLSearchParams(window.location.search);
        } catch (error) {
          return false;
        }
        const scentHandle = this.normalizeHandle(params.get('quiz_scent'));
        const device = this.normalizeHandle(params.get('quiz_device'));
        const plan = String(params.get('quiz_plan') || '').trim().toLowerCase();
        const routePlans = {
          benz: '15ml',
          whisper: '60ml',
          aura: '120ml',
          grand: '500ml'
        };
        if (!scentHandle || !device || !plan || routePlans[device] !== plan) return false;
        const routeButton = this.routeButtons.find((button) => button.dataset.route === device);
        if (!routeButton) return false;
        const scentButton = Array.from(this.querySelectorAll(`[data-scents-route="${device}"] [data-scent-variant]:not([disabled])`))
          .find((button) => (
            this.normalizeHandle(button.dataset.scentHandle) === scentHandle
            && String(button.dataset.scentSize || '').toLowerCase() === plan
            && Boolean(button.dataset.sellingPlan)
          ));
        if (!scentButton) return false;
        this.setRoute(device);
        this.selectScent(scentButton);
        this.dataset.quizFlow = 'true';
        this.classList.add('is-quiz-flow');
        this.updateQuizMatch();
        this.goTo('review', false);
        return true;
      }

      clearQuizFlow() {
        delete this.dataset.quizFlow;
        this.classList.remove('is-quiz-flow');
        this.querySelectorAll('[data-quiz-match]').forEach((element) => {
          element.hidden = true;
        });
      }

      updateQuizMatch() {
        const match = this.querySelector('[data-quiz-match]');
        if (!match || this.dataset.quizFlow !== 'true') return;
        this.updateText('[data-quiz-match-scent]', this.state.scentTitle || 'Your Verona scent');
        this.updateText('[data-quiz-match-device]', this.state.deviceTitle || 'your Verona diffuser');
        this.updateText('[data-quiz-match-plan]', this.state.requiredSize || 'matched');
        match.hidden = false;
      }

      normalizeHandle(value = '') {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      escapeHtml(value = '') {
        const map = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        };
        return String(value || '').replace(/[&<>"']/g, (character) => map[character]);
      }

      toTitleCase(value = '') {
        return String(value || '')
          .replace(/[-_]+/g, ' ')
          .replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
      }

      updateQuizAssistLink() {
        const link = this.querySelector('[data-quiz-assist-link]');
        if (!link) return;
        const base = this.dataset.quizUrl || link.getAttribute('href') || '/pages/scent-quiz';
        try {
          const url = new URL(base, window.location.origin);
          url.searchParams.set('return', 'subscription-offer');
          if (this.state.route) url.searchParams.set('device', this.state.route);
          link.href = url.pathname + url.search + url.hash;
        } catch (error) {
          link.href = base;
        }
      }

      goTo(slide, focus = true) {
        if (slide === 'review' && (!this.state.scentVariant || !this.state.sellingPlan)) {
          this.setOfferMessage(this.state.scentVariant
            ? 'This scent is not available for monthly checkout right now. Please choose another scent or contact us for help.'
            : 'Choose a monthly scent oil to continue.');
          return;
        }
        if (slide === 'scent' && !this.state.diffuserVariant) return;
        this.currentSlide = slide;
        this.slides.forEach((panel) => {
          const active = panel.dataset.slide === slide;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        this.stepButtons.forEach((button) => {
          const active = button.dataset.stepTarget === slide;
          button.classList.toggle('is-active', active);
          if (active) {
            button.setAttribute('aria-current', 'step');
          } else {
            button.removeAttribute('aria-current');
          }
        });
        if (focus) {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          if (isMobile) {
            const activePanel = this.querySelector(`[data-slide="${slide}"]`);
            const scrollTarget = activePanel?.querySelector('.subscription-offer__slide-head') || this.querySelector('.subscription-offer__slides');
            const header = document.querySelector('.shopify-section-header, sticky-header, header');
            const headerOffset = header ? header.getBoundingClientRect().height : 96;
            if (scrollTarget) {
              const top = scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
              window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
            }
          }
          if (!isMobile) {
            const target = this.querySelector(`[data-slide="${slide}"] h2`);
            target?.setAttribute('tabindex', '-1');
            target?.focus({ preventScroll: true });
          }
        }
        this.updateReview();
      }

      updateReview() {
        const hasSellingPlan = Boolean(this.state.sellingPlan);
        const ready = Boolean(this.state.diffuserVariant && this.state.scentVariant && hasSellingPlan);
        const originalCents = this.parseCents(this.state.scentPriceCents || this.state.paidPriceCents);
        const firstOrderCents = originalCents ? Math.round(originalCents * 0.9) : 0;
        const loyaltyCents = originalCents ? Math.round(originalCents * 0.85) : 0;
        const originalPrice = originalCents ? this.formatMoney(originalCents) : (this.state.scentPrice || this.state.paidPrice || '');
        const firstOrderPrice = firstOrderCents ? this.formatMoney(firstOrderCents) : originalPrice;
        const loyaltyPrice = loyaltyCents ? this.formatMoney(loyaltyCents) : '';
        this.updateText('[data-visual-title]', this.state.deviceTitle);
        this.updateText('[data-visual-copy]', this.state.visualCopy);
        this.updateText('[data-visual-value]', this.state.freeValue || '');
        this.updateText('[data-color-heading]', this.state.deviceTitle);
        this.updateText('[data-scent-heading]', 'Pick your first monthly scent.');
        this.updateText('[data-scent-subheading]', `Start with any ${this.state.requiredSize || '15ml'} oil. Your selected scent oil is billed monthly.`);
        this.updateText('[data-route-pill-device]', `${this.state.deviceTitle || ''} route`);
        this.updateText('[data-route-pill-price]', this.state.paidPrice || '');
        this.updateText('[data-review-device]', this.state.deviceTitle);
        this.updateText('[data-review-color]', this.state.colorTitle || '');
        this.updateText('[data-review-value]', this.state.freeValue || '');
        this.updateText('[data-review-scent]', this.state.scentTitle ? `${this.state.scentTitle} ${this.state.requiredSize}` : `Choose a ${this.state.requiredSize || '15ml'} scent oil`);
        this.updateText('[data-review-notes]', this.state.sellingPlanName ? `${this.state.sellingPlanName}. ${this.state.scentNotes || 'Fresh Verona scenting for the month ahead.'}` : 'This scent is not available for monthly checkout right now.');
        this.updateText('[data-review-price]', firstOrderPrice);
        this.updateText('[data-review-original-price]', originalPrice);
        this.updateText('[data-review-total-original]', originalPrice);
        this.updateText('[data-review-total]', firstOrderPrice);
        this.updateText('[data-review-loyalty]', loyaltyPrice ? `After your 3rd monthly refill, future refills become ${loyaltyPrice} with 15% off. Express shipping stays $0.` : 'After your 3rd monthly refill, future refills unlock 15% off automatically. Express shipping stays $0.');
        this.updateQuizMatch();
        this.querySelectorAll('[data-slide-next="review"]').forEach((button) => {
          button.disabled = !ready;
        });
        if (this.submitButton) this.submitButton.disabled = this.cartSubmissionInFlight || !ready;
        if (this.state.scentVariant && !hasSellingPlan) {
          this.setOfferMessage('This scent is not available for monthly checkout right now. Please choose another scent or contact us for help.');
        } else {
          this.setOfferMessage(ready
            ? `${this.state.scentTitle} ${this.state.requiredSize} selected. Review your free ${this.state.deviceTitle}.`
            : `Choose a ${this.state.requiredSize || '15ml'} monthly scent oil to unlock the free diffuser.`);
        }
      }

      setOfferMessage(value) {
        (this.messages || []).forEach((element) => {
          element.textContent = value || '';
        });
      }

      updateText(selector, value) {
        this.querySelectorAll(selector).forEach((element) => {
          element.textContent = value || '';
        });
      }

      parseCents(value) {
        const cents = Number(value);
        return Number.isFinite(cents) && cents > 0 ? cents : 0;
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || window.Shopify?.currency?.shopCurrency || 'USD';
        try {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      }

      async addOffer() {
        if (this.cartSubmissionInFlight || !this.submitButton) return;
        const root = window.Shopify?.routes?.root || '/';
        const themeRoutes = window.routes || window.theme?.routes || {};
        const cartAddUrl = `${root}cart/add.js`.replace('//', '/');
        const cartJsonUrl = `${root}cart.js`.replace('//', '/');
        const cartUrl = themeRoutes.cart_url || `${root}cart`.replace('//', '/');
        const offerCartUrl = `${cartUrl}${cartUrl.includes('?') ? '&' : '?'}subscription_offer=1`;
        let intent;
        try {
          intent = this.buildCartIntent();
        } catch (error) {
          this.setOfferMessage(error.message);
          return;
        }
        this.cartSubmissionInFlight = true;
        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Adding your plan…'));
        this.setOfferMessage('Adding your subscription offer...');
        let authoritativeCart;
        try {
          const existingCart = await this.fetchCart(cartJsonUrl, 6000);
          const existingState = this.inspectIntendedCartLines(existingCart, intent);
          if (existingState.complete) {
            authoritativeCart = existingCart;
          } else if (existingState.oil || existingState.diffuser) {
            throw new Error('Part of this plan is already in your cart. Please review your cart before trying again.');
          } else {
            try {
              await this.addCartItems(cartAddUrl, intent, 12000);
            } catch (error) {
              const recoveryCart = await this.fetchVerifiedCartAfterUncertainAdd(cartJsonUrl, intent);
              if (!recoveryCart) throw error;
              authoritativeCart = recoveryCart;
            }
          }

          authoritativeCart = authoritativeCart || await this.fetchCart(cartJsonUrl, 6000);
          const verifiedState = this.inspectIntendedCartLines(authoritativeCart, intent);
          if (!verifiedState.complete) {
            throw new Error('Your cart could not be verified. Please try again.');
          }
          if (!verifiedState.diffuserFree) {
            this.setOfferMessage('Your plan was added, but the complimentary diffuser price needs review. Opening your cart…');
            this.navigateToCartFallback(offerCartUrl);
            return;
          }
          try {
            window.sessionStorage.setItem('veronaSubscriptionOfferCart', String(Date.now()));
          } catch (error) {
            // Storage can be unavailable in private browsing; cart verification remains authoritative.
          }
          this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Opening cart…'));
          this.setOfferMessage('Your plan was added. Opening your cart…');
          const drawerReady = await this.openMoonbundleCartDrawerIfAvailable(intent, 'subscription-offer');
          if (!drawerReady) this.navigateToCartFallback(offerCartUrl);
        } catch (error) {
          this.setOfferMessage(error.message || 'This offer could not be added. Please try again.');
        } finally {
          this.cartSubmissionInFlight = false;
          document.body.classList.remove('subscription-offer-cart-routing');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-busy');
          this.submitButton.querySelector('span')?.replaceChildren(document.createTextNode('Add subscription offer to cart'));
          const ready = Boolean(this.state.diffuserVariant && this.state.scentVariant && this.state.sellingPlan);
          this.submitButton.disabled = !ready;
          this.scheduleScrollLockReconciliation();
        }
      }

      buildCartIntent() {
        const oilVariant = Number(this.state.scentVariant);
        const diffuserVariant = Number(this.state.diffuserVariant);
        const sellingPlan = Number(this.state.sellingPlan);
        const requiredValues = [oilVariant, diffuserVariant, sellingPlan];
        if (requiredValues.some((value) => !Number.isSafeInteger(value) || value <= 0)) {
          throw new Error('This plan is missing required checkout details. Please choose your scent again.');
        }
        if (!this.state.requiredSize || !this.state.deviceTitle || !this.state.scentTitle) {
          throw new Error('Please complete all plan selections before adding to cart.');
        }
        const offerName = this.dataset.offerName || 'Verona Monthly Scent Plan';
        const planTerms = 'Four monthly orders are required: today’s order plus three monthly renewals. You may cancel after completing order four.';
        const discountSchedule = 'Enjoy 10% off your first three subscription orders, followed by 15% off every order from your fourth onward.';
        const shippingTerms = 'Free express shipping across the U.S.';
        return {
          oilVariant,
          diffuserVariant,
          sellingPlan,
          scentTitle: this.state.scentTitle,
          deviceTitle: this.state.deviceTitle,
          items: [
            {
              id: oilVariant,
              quantity: 1,
              selling_plan: sellingPlan,
              properties: {
                '_Offer': offerName,
                '_Appstle subscription offer': 'true',
                '_Subscription': this.state.sellingPlanName || 'Monthly scent oil subscription',
                '_Oil size': this.state.requiredSize,
                '_Paired free diffuser': this.state.deviceTitle,
                '_Plan terms': planTerms,
                '_Discount schedule': discountSchedule,
                '_Express shipping': shippingTerms
              }
            },
            {
              id: diffuserVariant,
              quantity: 1,
              properties: {
                '_Offer': offerName,
                '_Free subscription diffuser': 'true',
                '_Free diffuser': this.state.deviceTitle,
                '_Color': this.state.colorTitle,
                '_Unlocked by': `${this.state.requiredSize} monthly scent oil`,
                '_Express shipping': shippingTerms
              }
            }
          ]
        };
      }

      async addCartItems(url, intent, timeout) {
        const config = window.fetchConfig
          ? window.fetchConfig('javascript')
          : { method: 'POST', headers: {} };
        config.method = 'POST';
        config.headers = config.headers || {};
        config.headers['Content-Type'] = 'application/json';
        config.headers['Accept'] = 'application/json';
        config.body = JSON.stringify({ items: intent.items });
        const response = await this.fetchWithTimeout(url, config, timeout);
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || payload.status) throw new Error(this.normalizeCartError(payload));
        return payload;
      }

      async fetchCart(url, timeout) {
        const response = await this.fetchWithTimeout(url, {
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        }, timeout);
        if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
        return response.json();
      }

      async fetchVerifiedCartAfterUncertainAdd(url, intent) {
        for (let attempt = 0; attempt < 3; attempt += 1) {
          const cart = await this.fetchCart(url, 6000).catch(() => null);
          if (cart && this.inspectIntendedCartLines(cart, intent).complete) return cart;
          if (attempt < 2) await new Promise((resolve) => window.setTimeout(resolve, 700));
        }
        return null;
      }

      async fetchWithTimeout(url, options = {}, timeout = 12000) {
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        let timedOut = false;
        let rejectTimeout;
        const timeoutPromise = new Promise((resolve, reject) => {
          rejectTimeout = reject;
        });
        const timer = window.setTimeout(() => {
          timedOut = true;
          controller?.abort();
          rejectTimeout(new Error('The cart is taking longer than expected. Please try again.'));
        }, timeout);
        try {
          return await Promise.race([
            fetch(url, { ...options, ...(controller ? { signal: controller.signal } : {}) }),
            timeoutPromise
          ]);
        } catch (error) {
          if (timedOut || error?.name === 'AbortError') throw new Error('The cart is taking longer than expected. Please try again.');
          throw new Error('The cart could not be reached. Check your connection and try again.');
        } finally {
          window.clearTimeout(timer);
        }
      }

      withPromiseTimeout(value, timeout, message) {
        let timer;
        const deadline = new Promise((resolve, reject) => {
          timer = window.setTimeout(() => reject(new Error(message)), timeout);
        });
        return Promise.race([Promise.resolve(value), deadline]).finally(() => window.clearTimeout(timer));
      }

      inspectIntendedCartLines(cart, intent) {
        const items = Array.isArray(cart?.items) ? cart.items : [];
        const planId = (item) => Number(item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan_allocation?.selling_plan_id || item?.selling_plan || 0);
        const oilMatches = items.filter((item) => Number(item.variant_id || item.id) === intent.oilVariant
          && planId(item) === intent.sellingPlan
          && item.properties?.['_Appstle subscription offer'] === 'true');
        const diffuserMatches = items.filter((item) => Number(item.variant_id || item.id) === intent.diffuserVariant
          && !planId(item)
          && item.properties?.['_Free subscription diffuser'] === 'true');
        const oil = oilMatches.length > 0;
        const diffuser = diffuserMatches.length > 0;
        const oilValid = oilMatches.length === 1 && Number(oilMatches[0].quantity) === 1;
        const diffuserValid = diffuserMatches.length === 1 && Number(diffuserMatches[0].quantity) === 1;
        const diffuserFree = items.some((item) => Number(item.variant_id || item.id) === intent.diffuserVariant
          && item.properties?.['_Free subscription diffuser'] === 'true'
          && Number(item.final_line_price) === 0);
        return { oil, diffuser, diffuserFree, complete: oilValid && diffuserValid };
      }

      restoreMoonbundleElements() {
        document.querySelectorAll('#moonbundle-cart-drawer, #moonbundle-cart-drawer-overlay, moonbundle-cart-drawer-block, .moonbundle-cart-drawer, .moonbundle-cart-drawer-overlay').forEach((element) => {
          element.style.removeProperty('display');
          element.style.removeProperty('visibility');
          element.style.removeProperty('opacity');
          element.style.removeProperty('pointer-events');
          element.removeAttribute('aria-hidden');
        });
      }

      async openMoonbundleCartDrawerIfAvailable(intent, reason = 'subscription-offer') {
        try {
          document.body.classList.remove('subscription-offer-cart-routing');
          this.restoreMoonbundleElements();
          const detail = { caller: 'subscription-offer', source: 'subscription-offer', reason };
          document.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail }));
          window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail }));
          const drawer = document.querySelector('moonbundle-cart-drawer-block');
          if (!drawer) return false;
          this.moonbundlePresentationActive = true;
          if (typeof drawer.loadCart === 'function') {
            await this.withPromiseTimeout(drawer.loadCart(reason), 6500, 'Moonbundle cart refresh timed out.');
          }
          const rendered = await this.waitForMoonbundleCartContent(drawer, intent, 6500);
          if (!rendered) return false;
          if (typeof drawer.open === 'function') {
            await this.withPromiseTimeout(drawer.open(true), 2500, 'Moonbundle cart open timed out.');
          } else if (typeof drawer.openImmediate === 'function') {
            await this.withPromiseTimeout(drawer.openImmediate(), 2500, 'Moonbundle cart open timed out.');
          } else if (typeof window.openMoonBundleCartDrawer === 'function') {
            await this.withPromiseTimeout(window.openMoonBundleCartDrawer(), 2500, 'Moonbundle cart open timed out.');
          } else {
            return false;
          }
          this.alignMoonbundleCommitmentCopy(drawer);
          return this.waitForMoonbundleDrawerUsability(drawer, intent, 3500);
        } catch (error) {
          console.warn('Moonbundle cart drawer refresh failed, falling back to the Shopify cart.', error);
          return false;
        } finally {
          this.moonbundlePresentationActive = false;
        }
      }

      waitForMoonbundleCartContent(drawer, intent, timeout) {
        if (this.moonbundleDrawerContainsOffer(drawer, intent)) return Promise.resolve(true);
        return new Promise((resolve) => {
          let settled = false;
          const finish = (value) => {
            if (settled) return;
            settled = true;
            observer.disconnect();
            window.clearTimeout(timer);
            resolve(value);
          };
          const observer = new MutationObserver(() => {
            this.alignMoonbundleCommitmentCopy(drawer);
            if (this.moonbundleDrawerContainsOffer(drawer, intent)) finish(true);
          });
          observer.observe(drawer.shadowRoot || drawer, { childList: true, subtree: true, characterData: true });
          const timer = window.setTimeout(() => finish(false), timeout);
        });
      }

      moonbundleDrawerContainsOffer(drawer, intent) {
        const roots = [drawer, drawer?.shadowRoot].filter(Boolean);
        const text = roots.map((root) => root.textContent || '').join(' ').toLowerCase();
        const scent = String(intent.scentTitle || '').toLowerCase();
        const device = String(intent.deviceTitle || '').toLowerCase();
        return Boolean(scent && device && text.includes(scent) && text.includes(device));
      }

      getMoonbundleRoots(drawer) {
        return [drawer?.shadowRoot, drawer, document].filter((root, index, roots) => root && roots.indexOf(root) === index);
      }

      findMoonbundleElement(drawer, selector) {
        for (const root of this.getMoonbundleRoots(drawer)) {
          const element = root.querySelector?.(selector);
          if (element) return element;
        }
        return null;
      }

      findMoonbundleElements(drawer, selector) {
        const elements = [];
        this.getMoonbundleRoots(drawer).forEach((root) => {
          root.querySelectorAll?.(selector).forEach((element) => {
            if (!elements.includes(element)) elements.push(element);
          });
        });
        return elements;
      }

      findMoonbundleCheckoutControl(content) {
        const selectors = [
          '.moonbundle-cart-drawer-checkout',
          '[data-moonbundle-checkout]',
          '[data-checkout]',
          'button[name="checkout"]',
          'a[href*="/checkout"]'
        ];
        for (const selector of selectors) {
          const control = content?.querySelector?.(selector);
          if (control) return control;
        }
        return Array.from(content?.querySelectorAll?.('button, a') || [])
          .find((element) => /checkout/i.test(element.textContent || '')) || null;
      }

      isMeaningfullyOnscreen(element, { requireInteraction = false } = {}) {
        if (!element || element.hidden || element.getAttribute?.('aria-hidden') === 'true') return false;
        for (let ancestor = element; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
          if (ancestor.hidden || ancestor.inert || ancestor.getAttribute?.('aria-hidden') === 'true') return false;
          const ancestorStyles = window.getComputedStyle(ancestor);
          if (ancestorStyles.display === 'none' || ancestorStyles.visibility === 'hidden' || Number(ancestorStyles.opacity) === 0) return false;
        }
        const styles = window.getComputedStyle(element);
        if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return false;
        if (requireInteraction && (styles.pointerEvents === 'none' || element.disabled || element.getAttribute?.('aria-disabled') === 'true')) return false;
        const rect = element.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        if (!viewportWidth || !viewportHeight || rect.width < 32 || rect.height < 32) return false;
        if (rect.left >= viewportWidth || rect.right <= 0 || rect.top >= viewportHeight || rect.bottom <= 0) return false;
        const intersectionWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);
        const intersectionHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        if (intersectionWidth < Math.min(48, rect.width * 0.25) || intersectionHeight < Math.min(48, rect.height * 0.1)) return false;
        if (requireInteraction && typeof document.elementFromPoint === 'function') {
          const x = rect.left + rect.width / 2;
          const y = rect.top + rect.height / 2;
          if (x < 0 || x >= viewportWidth || y < 0 || y >= viewportHeight) return false;
          let topElement = document.elementFromPoint(x, y);
          if (!topElement) return false;
          while (topElement?.shadowRoot?.elementFromPoint) {
            const shadowElement = topElement.shadowRoot.elementFromPoint(x, y);
            if (!shadowElement || shadowElement === topElement) break;
            topElement = shadowElement;
          }
          if (topElement !== element && !element.contains(topElement)) return false;
        }
        return true;
      }

      isMoonbundleDrawerContentUsable(drawer, intent = null) {
        return this.findMoonbundleElements(drawer, '.moonbundle-cart-drawer-content').some((content) => {
          const root = content.getRootNode?.() || document;
          const shell = content.closest?.('#moonbundle-cart-drawer, .moonbundle-cart-drawer')
            || root.querySelector?.('#moonbundle-cart-drawer, .moonbundle-cart-drawer');
          if (!shell || !shell.contains(content) || !this.isMeaningfullyOnscreen(shell) || !this.isMeaningfullyOnscreen(content, { requireInteraction: true })) return false;
          const checkout = this.findMoonbundleCheckoutControl(content);
          if (!checkout || !this.isMeaningfullyOnscreen(checkout, { requireInteraction: true })) return false;
          const text = (content.textContent || '').toLowerCase();
          if (!intent) return Boolean(text.trim());
          const scent = String(intent.scentTitle || '').toLowerCase();
          const device = String(intent.deviceTitle || '').toLowerCase();
          return Boolean(scent && device && text.includes(scent) && text.includes(device));
        });
      }

      waitForMoonbundleDrawerUsability(drawer, intent, timeout = 3500) {
        if (this.isMoonbundleDrawerContentUsable(drawer, intent)) return Promise.resolve(true);
        return new Promise((resolve) => {
          let settled = false;
          const finish = (value) => {
            if (settled) return;
            settled = true;
            observer.disconnect();
            window.clearInterval(retryTimer);
            window.clearTimeout(timeoutTimer);
            resolve(value);
          };
          const check = () => {
            this.alignMoonbundleCommitmentCopy(drawer);
            if (this.isMoonbundleDrawerContentUsable(drawer, intent)) finish(true);
          };
          const observer = new MutationObserver(check);
          observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'disabled']
          });
          const retryTimer = window.setInterval(check, 300);
          const timeoutTimer = window.setTimeout(() => finish(false), timeout);
        });
      }

      hideUnusableMoonbundleDrawer() {
        const drawer = document.querySelector('moonbundle-cart-drawer-block');
        try {
          if (drawer && typeof drawer.close === 'function') drawer.close();
        } catch (error) {
          // Inline fallback cleanup below remains authoritative.
        }
        document.querySelectorAll('moonbundle-cart-drawer-block, #moonbundle-cart-drawer, #moonbundle-cart-drawer-overlay, .moonbundle-cart-drawer, .moonbundle-cart-drawer-overlay').forEach((element) => {
          element.classList.remove('open', 'active', 'is-open');
          element.setAttribute('aria-hidden', 'true');
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
        });
        if (!this.hasVisibleOverlayOwner() && !this.hasVisibleKlaviyoSurface()) {
          document.body.classList.remove('klaviyo-prevent-body-scrolling');
          document.documentElement.style.removeProperty('overflow');
          document.body.style.removeProperty('overflow');
        }
      }

      alignMoonbundleCommitmentCopy(root = document) {
        const containers = root === document
          ? Array.from(document.querySelectorAll('#moonbundle-cart-drawer, moonbundle-cart-drawer-block, .moonbundle-cart-drawer'))
          : [root];
        containers.forEach((container) => {
          const scanRoot = container.shadowRoot || container;
          const walker = document.createTreeWalker(scanRoot, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const conflictingClaim = /Try\s+Risk(?:-|\s)Free\s+For\s+30\s+Days/i;
            if (conflictingClaim.test(node.nodeValue || '')) {
              node.nodeValue = node.nodeValue.replace(conflictingClaim, 'Try Risk-Free For 30 Days');
            }
          }
        });
      }

      navigateToCartFallback(url) {
        if (this.cartFallbackStarted) return;
        this.cartFallbackStarted = true;
        this.hideUnusableMoonbundleDrawer();
        this.setOfferMessage('Your plan was added. Opening your cart…');
        window.location.assign(url);
      }

      normalizeCartError(payload = {}) {
        const raw = String(payload.description || payload.message || '').trim();
        if (!raw) return 'This offer could not be added. Please refresh and try again.';
        const lower = raw.toLowerCase();
        if (lower.includes('épuis') || lower.includes('indisponible') || lower.includes('stock') || lower.includes('available')) {
          return 'One of the selected items is unavailable. Please choose another option and try again.';
        }
        if (lower.includes('quantit') || lower.includes('quantity')) {
          return 'The selected quantity is not available. Please refresh and try again.';
        }
        return 'This offer could not be added. Please refresh and try again.';
      }

    });
  }
  } catch(e) { console.error(e); }
})();

})();
